export const NAV = {
    home: 'nav-home-link',
    claims: 'nav-claims-link',
    howItWorks: 'nav-how-it-works-link',
    about: 'nav-about-link',
    faq: 'nav-faq-link',
    contact: 'nav-contact-link',
    startClaimCta: 'nav-start-claim-cta',
    mobileToggle: 'nav-mobile-toggle',
    logo: 'nav-logo-link',
};

export const HERO = {
    headline: 'hero-headline',
    primaryCta: 'hero-primary-cta',
    secondaryCta: 'hero-secondary-cta',
    sectorPicker: 'hero-sector-picker',
};

export const SECTOR = {
    grid: 'sector-grid',
    card: (slug) => `sector-card-${slug}`,
    startClaim: (slug) => `sector-start-claim-${slug}`,
    headerTitle: 'sector-header-title',
    detailCta: 'sector-detail-start-cta',
};

export const CLAIM = {
    wizard: 'claim-wizard',
    progressBar: 'claim-progress-bar',
    nextButton: 'claim-next-button',
    backButton: 'claim-back-button',
    submitButton: 'claim-submit-button',
    sectorSelect: 'claim-sector-select',
    fullName: 'claim-full-name-input',
    email: 'claim-email-input',
    phone: 'claim-phone-input',
    postcode: 'claim-postcode-input',
    gdprConsent: 'claim-gdpr-consent',
    marketingConsent: 'claim-marketing-consent',
    successScreen: 'claim-success-screen',
    successReference: 'claim-success-reference',
    field: (key) => `claim-field-${key}`,
};

export const FOOTER = {
    root: 'footer-root',
    legalLink: (slug) => `footer-legal-${slug}`,
};

export const STICKY = {
    bar: 'sticky-mobile-cta',
};
